import React from 'react';
import Tetris from './components/Tetris';

const App = () => (
  <div className="app">
    <Tetris />
  </div>
);

export default App;
